import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectIsLogged = createSelector(
  (state: RootState) => state.user.isLogged,
  (isLogged: boolean) => isLogged
)

export default selectIsLogged
